<div class="carousel-container">
  <div
    class="carousel-wrapper"
    (touchstart)="onTouchStart($event)"
    (touchend)="onTouchEnd($event)"
    (mousedown)="onMouseDown($event)"
    (mouseup)="onMouseUp($event)"
  >
    <div
      #carouselTrack
      class="carousel-track"
      [style.transform]="'translateX(-' + currentIndex * 100 + '%)'"
    >
      <ng-content></ng-content>
    </div>
  </div>

  @if (showDots && totalSlides > 1) {
    <div class="carousel-dots">
      @for (dot of dots; track dot) {
        <button
          type="button"
          class="carousel-dot"
          [class.active]="currentIndex === dot"
          (click)="goToSlide(dot)"
          [attr.aria-label]="'Go to slide ' + (dot + 1)"
          [attr.aria-current]="currentIndex === dot ? 'true' : 'false'"
        ></button>
      }
    </div>
  }
</div>
